import {VisualProductCard} from 'modules/products/components/VisualProductCard';
import {IProductShort, TProductListView} from 'modules/products/types';
import React, {forwardRef, memo, MouseEventHandler} from 'react';
import cs from 'classnames';
import style from './style.module.scss';
import {IAnalyticsMeta} from 'core/types';
import {ProductSnippetContainer as VerticalProductSnippet} from 'modules/product-snippet/components/ProductSnippetContainer';
import {ProductSnippetAnalyticsProvider} from 'modules/analytics/providers/ProductSnippetAnalyticsProvider';

export interface IProps {
    listType?: TProductListView;
    className?: string;
    onClick?: MouseEventHandler<HTMLDivElement>;
    analytics?: IAnalyticsMeta;
}

export type TCommonProductCardProps = IProps & IProductShort;

export const ProductSnippet = memo(
    forwardRef<HTMLDivElement, TCommonProductCardProps>(function ProductSnippet(
        {onClick, className, analytics, listType = 'tile', ...restProductCardAttr},
        ref,
    ) {
        return (
            <ProductSnippetAnalyticsProvider>
                <div
                    className={cs(style.main, 'product-card-wrapper')}
                    data-product-card-id={restProductCardAttr.offerId}
                    onClick={onClick}
                    ref={ref}
                >
                    {'tile' === listType ? (
                        <VerticalProductSnippet
                            product={restProductCardAttr}
                            analyticsData={analytics}
                            hasBorder={true}
                            tracking={{skipOnViewTracking: true}}
                        />
                    ) : (
                        <VisualProductCard {...restProductCardAttr} analytics={analytics} listType={'list'} />
                    )}
                </div>
            </ProductSnippetAnalyticsProvider>
        );
    }),
    (prevProps, nextProps) => {
        return prevProps.offerId === nextProps.offerId && prevProps.listType === nextProps.listType;
    },
);
